// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-icon-container {
    position: relative;
    margin-right: 16px;
}

.notification-icon-button {
    position: relative;
    background: none;
    border: none;
    cursor: pointer;
    padding: 8px;
    color: #333;
    font-size: 20px;
    transition: color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.notification-icon-button:hover {
    color: #2d8659;
}

.notification-badge {
    position: absolute;
    top: 4px;
    right: 4px;
    background-color: #f44336;
    color: white;
    border-radius: 10px;
    padding: 2px 6px;
    font-size: 11px;
    font-weight: bold;
    min-width: 18px;
    text-align: center;
    line-height: 14px;
}

.notification-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    width: 380px;
    max-height: 500px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 1000;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.notification-dropdown-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #e0e0e0;
}

.notification-dropdown-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.mark-all-read-button {
    background: none;
    border: none;
    color: #2d8659;
    font-size: 14px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background-color 0.2s;
}

.mark-all-read-button:hover {
    background-color: #f0f0f0;
}

.notification-dropdown-content {
    flex: 1;
    overflow-y: auto;
    max-height: 400px;
}

.notification-loading,
.notification-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    color: #999;
}

.notification-loading i,
.notification-empty i {
    font-size: 32px;
    margin-bottom: 12px;
}

.notification-list {
    padding: 8px 0;
}

.notification-item {
    display: flex;
    align-items: flex-start;
    padding: 12px 16px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
    transition: background-color 0.2s;
    position: relative;
}

.notification-item:hover {
    background-color: #f9f9f9;
}

.notification-item.unread {
    background-color: #f0f7ff;
}

.notification-item.unread:hover {
    background-color: #e6f2ff;
}

.notification-item-content {
    flex: 1;
    min-width: 0;
    text-align: left;
}

.notification-item-actions {
    display: flex;
    align-items: center;
    margin-left: 8px;
    opacity: 0;
    transition: opacity 0.2s;
}

.notification-item:hover .notification-item-actions {
    opacity: 1;
}

.notification-delete-button {
    background: none;
    border: none;
    color: #999;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.notification-delete-button:hover {
    background-color: #fee;
    color: #f44336;
}

.notification-title {
    font-weight: 600;
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
    text-align: left;
}

.notification-message {
    font-size: 13px;
    color: #666;
    margin-bottom: 6px;
    line-height: 1.4;
    word-wrap: break-word;
    text-align: left;
}

.notification-time {
    font-size: 11px;
    color: #999;
    text-align: left;
}

.notification-unread-indicator {
    width: 8px;
    height: 8px;
    background-color: #2d8659;
    border-radius: 50%;
    margin-left: 12px;
    margin-top: 6px;
    flex-shrink: 0;
}

.notification-dropdown-footer {
    padding: 12px 16px;
    border-top: 1px solid #e0e0e0;
    text-align: left;
    font-size: 12px;
    color: #999;
    background-color: #f9f9f9;
}

/* Scrollbar styling */
.notification-dropdown-content::-webkit-scrollbar {
    width: 6px;
}

.notification-dropdown-content::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.notification-dropdown-content::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

.notification-dropdown-content::-webkit-scrollbar-thumb:hover {
    background: #555;
}
`, "",{"version":3,"sources":["webpack://./src/components/NotificationIcon/NotificationIcon.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".notification-icon-container {\n    position: relative;\n    margin-right: 16px;\n}\n\n.notification-icon-button {\n    position: relative;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 8px;\n    color: #333;\n    font-size: 20px;\n    transition: color 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.notification-icon-button:hover {\n    color: #2d8659;\n}\n\n.notification-badge {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    background-color: #f44336;\n    color: white;\n    border-radius: 10px;\n    padding: 2px 6px;\n    font-size: 11px;\n    font-weight: bold;\n    min-width: 18px;\n    text-align: center;\n    line-height: 14px;\n}\n\n.notification-dropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    width: 380px;\n    max-height: 500px;\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.notification-dropdown-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 16px;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.notification-dropdown-header h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.mark-all-read-button {\n    background: none;\n    border: none;\n    color: #2d8659;\n    font-size: 14px;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 4px;\n    transition: background-color 0.2s;\n}\n\n.mark-all-read-button:hover {\n    background-color: #f0f0f0;\n}\n\n.notification-dropdown-content {\n    flex: 1;\n    overflow-y: auto;\n    max-height: 400px;\n}\n\n.notification-loading,\n.notification-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 40px 20px;\n    color: #999;\n}\n\n.notification-loading i,\n.notification-empty i {\n    font-size: 32px;\n    margin-bottom: 12px;\n}\n\n.notification-list {\n    padding: 8px 0;\n}\n\n.notification-item {\n    display: flex;\n    align-items: flex-start;\n    padding: 12px 16px;\n    border-bottom: 1px solid #f0f0f0;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    position: relative;\n}\n\n.notification-item:hover {\n    background-color: #f9f9f9;\n}\n\n.notification-item.unread {\n    background-color: #f0f7ff;\n}\n\n.notification-item.unread:hover {\n    background-color: #e6f2ff;\n}\n\n.notification-item-content {\n    flex: 1;\n    min-width: 0;\n    text-align: left;\n}\n\n.notification-item-actions {\n    display: flex;\n    align-items: center;\n    margin-left: 8px;\n    opacity: 0;\n    transition: opacity 0.2s;\n}\n\n.notification-item:hover .notification-item-actions {\n    opacity: 1;\n}\n\n.notification-delete-button {\n    background: none;\n    border: none;\n    color: #999;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 4px;\n    transition: all 0.2s;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.notification-delete-button:hover {\n    background-color: #fee;\n    color: #f44336;\n}\n\n.notification-title {\n    font-weight: 600;\n    font-size: 14px;\n    color: #333;\n    margin-bottom: 4px;\n    text-align: left;\n}\n\n.notification-message {\n    font-size: 13px;\n    color: #666;\n    margin-bottom: 6px;\n    line-height: 1.4;\n    word-wrap: break-word;\n    text-align: left;\n}\n\n.notification-time {\n    font-size: 11px;\n    color: #999;\n    text-align: left;\n}\n\n.notification-unread-indicator {\n    width: 8px;\n    height: 8px;\n    background-color: #2d8659;\n    border-radius: 50%;\n    margin-left: 12px;\n    margin-top: 6px;\n    flex-shrink: 0;\n}\n\n.notification-dropdown-footer {\n    padding: 12px 16px;\n    border-top: 1px solid #e0e0e0;\n    text-align: left;\n    font-size: 12px;\n    color: #999;\n    background-color: #f9f9f9;\n}\n\n/* Scrollbar styling */\n.notification-dropdown-content::-webkit-scrollbar {\n    width: 6px;\n}\n\n.notification-dropdown-content::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n.notification-dropdown-content::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 3px;\n}\n\n.notification-dropdown-content::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
